import type { IconProps } from './types';

export function Saia({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M92 52 Q128 48 164 52 Q164 64 164 76 Q190 148 216 220 Q128 224 40 220 Q66 148 92 76 Q92 64 92 52 Z" />
      <path d="M88 76 Q128 80 168 76" />
    </svg>
  );
}
